<template>
  <CBadge
    v-if="visible"
    color="info"
    shape="pill"
    class="badge-erp"
    :title="titulo"
  >ERP</CBadge>
</template>

<script>
export default {
  name: "BadgeErp",
  props: {
    campo: { type: String, required: true },
    camposSincronizados: { type: Array, default: () => [] },
  },
  computed: {
    visible() {
      return this.camposSincronizados.includes(this.campo);
    },
    titulo() {
      return "Alterações feitas via painel poderão ser substituídas pelas informações do ERP na próxima sincronização de dados";
    },
  },
};
</script>

<style scoped>
.badge-erp {
  font-size: 9px;
  vertical-align: middle;
  margin-left: 4px;
}
</style>
